import type { FsmCompletedWorkType } from "@fp/admin-api-client/types/fsmCompletedWorkType";
import type { FsmPlatform } from "@fp/admin-api-client/types/fsmPlatform";
import type { FsmPlatformStatus } from "@fp/admin-api-client/types/fsmPlatformStatus";

export const fsmPlatformStatusLabels: Record<FsmPlatformStatus, string> = {
  ComingSoon: "Coming soon",
  GenerallyAvailable: "Generally available",
  Private: "Private",
};

export const fsmPlatformLabels: Record<FsmPlatform, string> = {
  ColdStandard: "Cold Standard",
  HousecallPro: "Housecall Pro",
  PoolBrain: "PoolBrain",
  ServiceTitan: "ServiceTitan",
  Skimmer: "Skimmer",
};

export const fsmCompletedWorkTypeLabels: Record<FsmCompletedWorkType, string> = {
  Invoice: "Invoice",
  RouteStop: "Route Stop",
  WorkOrder: "Work Order",
  Visit: "Visit",
  Reimbursement: "Reimbursement",
};
